import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation Create($data: CreateAdmissionWayInput!) {
    createAdmissionWay(data: $data) {
      id
    }
  }
`);

export const responseCreateKey = "createAdmissionWay";
export interface CreateGql {
  createAdmissionWay: {
    id: number;
  };
}
